import { LeftOutlined, LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { Avatar, Badge, Button, Divider, Spin, Tooltip } from "antd";
import Cookies from "js-cookie";
import { debounce, delay } from "lodash";
import moment from "moment-timezone";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { FiSend } from "react-icons/fi";
import { GoPersonAdd } from "react-icons/go";
import { HiRefresh } from "react-icons/hi";
import { HiMiniUserGroup } from "react-icons/hi2";
import { IoMenu, IoSearchSharp } from "react-icons/io5";
import { LuAlarmClock, LuPhone, LuVideo } from "react-icons/lu";
import {
  MdExitToApp,
  MdKeyboardDoubleArrowUp,
  MdOutlineGroupOff,
  MdOutlineHowToVote,
} from "react-icons/md";
import { VscLayoutSidebarRight } from "react-icons/vsc";
import { v4 as uuidv4 } from "uuid";
import apiFactory from "../../../api";
import AvatarComponent from "../../../components/avatar/AvatarComponent";
import { GenerateMessageContent } from "../../../components/chat/MessageContent";
import { AddMemberModal } from "../../../components/modal/AddMemberModal";
import { ChatScheduleModal } from "../../../components/modal/chat/ChatScheduleModal";
import CreateVoteModal from "../../../components/modal/chat/CreateVoteModal";
import EditGroupModal from "../../../components/modal/chat/EditGroupModal";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import { MemberModal } from "../../../components/modal/MemberModal";
import MemberReadUnreadModal from "../../../components/modal/MemberReadUnreadModal";
import { ShareMessageModal } from "../../../components/modal/ShareMessageModal";
import StickerItem from "../../../components/moodPack/sticker/StickerItem";
import StickerTable from "../../../components/moodPack/sticker/StickerTable";
import { FilesPreview } from "../../../components/preview/FilesPreview";
import { ContentEditableRichInput } from "../../../components/richInput/ContentEditableRichInput";
import { DirectoryProvider } from "../../../components/select/directory/DirectoryContext";
import { FileSending } from "../../../components/select/FileSending";
import { SideBarConversation } from "../../../components/sideBar/SideBarConversation";
import {
  CHATTING,
  conversationStatus,
  conversationType,
  exceedFiles,
  imagesTypes,
  MAX_FILE_SIZE,
  MESSAGE_STATUS,
  PANEL_STATUS,
  role,
} from "../../../config/Constant";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { useChatContext } from "../../../context/ChatContext";
import { useMenuContext } from "../../../context/MenuContext";
import { useUploadFileStore } from "../../../store/UploadFileStore";
import { useInfoUser } from "../../../store/UserStore";
import { updateOrgList } from "../../../utils/OrganizationHelper";
import {
  extractUserIds,
  getAvatar,
  getColorFromInitial,
  onChangeUnreadConversation,
  openNotificationError,
  openNotificationSuccess,
  processFileUrl,
  removeAccents,
} from "../../../utils/Utils";
import { ChatPreviewLink } from "./ChatPreviewLink";
import { NewMessage } from "./NewMessage";
import { GroupInfoPanel } from "./panel/GroupInfoPanel";
import { MediaStoragePanel } from "./panel/MediaStoragePanel";
import { SearchPanel } from "./panel/SearchPanel";
import { PinnedMessageModal } from "./PinnedMessageModal";
import { QuotationResponse } from "./Quotation";
import "./style.scss";
import { PickMemberModal } from "../../../components/modal/calling/PickMemberModal";
import { OnOffTime } from "../../../components/avatar/OnOffTime";
import { MemberAvatar } from "../../../components/avatar/ProfileAvatar";

const fileStore = process.env.REACT_APP_FILE_STORE || "http://10.1.1.230:8000";

const UnreadCountCircle = () => {
  const {
    jumpToMessage,
    firstMessageUnread,
    isMessageUnread,
    setIsMessageUnread,
    unreadInDOM,
    selectedConversation,
  } = useChatContext();

  if (!isMessageUnread || selectedConversation?.unreadCount - unreadInDOM <= 0)
    return;

  return (
    <Badge
      count={selectedConversation?.unreadCount - unreadInDOM}
      color="#2a56b9"
      className="absolute top-[15%] left-[95%] z-[2]"
    >
      <Button
        shape="circle"
        size="large"
        icon={<MdKeyboardDoubleArrowUp size={30} />}
        onClick={() => {
          if (!firstMessageUnread) return;
          jumpToMessage(firstMessageUnread);
          setIsMessageUnread(false);
        }}
      />
    </Badge>
  );
};

const UnreadLine = ({ message }) => {
  const { firstMessageUnread } = useChatContext();

  if (message?.requestUuid !== firstMessageUnread?.requestUuid) return;

  return (
    <Divider style={{ borderColor: "#2a56b9" }} className="text-blue-500">
      <div className="bg-white text-[14px] text-[#2a56b9] px-3 py-1 rounded-full shadow-sm">
        Unread messages
      </div>
    </Divider>
  );
};

const TotalMember = () => {
  const { languageMap } = useInfoUser();
  const { selectedConversation } = useMenuContext();

  const { messageList } = useChatContext();
  const [openModalShowMember, setOpenModalShowMember] = useState(false);

  const showModalShowMember = () => {
    setOpenModalShowMember(true);
  };
  const handleCancelModalShowMember = () => {
    setOpenModalShowMember(false);
  };

  if (selectedConversation?.type !== conversationType.GROUP) return null;

  return (
    <>
      <button onClick={showModalShowMember}>
        <span>
          <UserOutlined className="bg-[#2a56b9] mr-1 text-[white] p-[4px] rounded-[2px]" />
          <span className="mr-1">{messageList?.[1]?.memberCount}</span>
          {languageMap?.["messageList.header.prefixMember"] ?? "members"}
        </span>
      </button>
      {openModalShowMember && (
        <DirectoryProvider>
          <MemberModal
            selectedConversation={selectedConversation}
            openModalShowMember={openModalShowMember}
            handleCancelModalShowMember={handleCancelModalShowMember}
          />
        </DirectoryProvider>
      )}
    </>
  );
};
const ChatDetail = () => {
  const { user, languageMap, stickerKeywords } = useInfoUser();

  /** Context */
  const {
    setOrgList: setOriginalOrgList,
    setCallingType,
    openCall,
  } = useAuthLayoutContext();
  const [orgList, setOrgList] = useState([]);
  const {
    selectedConversation,
    conversationList,
    handleUpdateConversationList,
    isMenu,
    refreshChatMessage,
    onSearch,
    setIsMenu,
    setSelectedConversation,
    quotation,
    setQuotation,
    personalDetail,
    setKeydownMenuOn,
    panelStatus,
    setPanelStatus,
  } = useMenuContext();

  const {
    messageList,
    setMessageList,
    formData,
    setFormData,
    sendFormData,
    lastMessageTs,
    setLastMessageTs,
    setIsMoreMessage,
    isMoreMessage,
    setIsModalAddMember,
    isOpenModalConfirm,
    setIsOpenModalConfirm,
    onBackToConversations,
    isModalAddMember,
    openAddMemberModal,
    openModalConfirm,
    setIsNewMessage,
    setIsViewTargetMessage,
    isViewTargetMessage,
    viewTargetMessage,
    previousScrollRef,
    messageRef,
    messageMapRef,
    handleTyping,
    typingUsers,
    pinnedMessages,
    isEnableGroup,
    setIsEnableGroup,
    isChatScheduleModal,
    setIsChatScheduleModal,
    setScheduleMessage,
    wasAtBottomMessageRef,
    jumpedRef,
    updateInitScrollRef,
    updateFirstScrollRef,
    setIsScrollToLastMessage,
    isLoading,
    setIsLoading,
    jumpToMessage,
    isJumping,
    searchCacheMention,
    setSearchCacheMention,
    isExitGroup,
    inputValue,
    setInputValue,
    setUnreadInDOM,
    setIsMessageUnread,
    getMember,
  } = useChatContext();

  const { uploadFiles, setUploadFiles } = useUploadFileStore();

  const [isPickCallMember, setIsPickCallMember] = useState(false);

  const mentionCallbackRef = useRef(null);
  const mentionSearchRef = useRef(null);
  const inputSendRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalMembersReadUnread, setIsModalMembersReadUnread] =
    useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const firstObserver = useRef();
  const lastObserver = useRef();
  const [isShareMessageModal, setIsShareMessageModal] = useState(false);
  const [dataShare, setDataShare] = useState(null);
  const [heightHeader, setHeightHeader] = useState(50);
  const [mediaVideo, setMediaVideo] = useState({
    mediaVideoSrc: null,
    shortName: null,
  });
  const [isOpenModalVote, setIsOpenModalVote] = useState(false);
  const [showSticker, setShowSticker] = useState(false);
  const [stickerSuggestions, setStickerSuggestions] = useState([]);

  const observerRef = useRef(null);
  const headerRef = useRef(null);

  const firstElementRef = (node) => {
    if (isLoading || !isMoreMessage) return;

    if (firstObserver.current) firstObserver.current.disconnect();

    firstObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);
        previousScrollRef.current = messageRef.current.scrollHeight;

        const res = await apiFactory.messageApi.getList({
          limit: CHATTING.MESSAGE_LIMIT,
          maxTs: lastMessageTs,
          search: {
            conversationId: selectedConversation?.conversationId,
          },
          direction: "DESC",
        });

        if (res?.status !== 200) {
          openNotificationError(res?.message);
          return;
        }

        const messList = res?.data
          ?.map((item) => ({
            ...item,
            isSelf: item?.senderId === user?.userId,
            username: getMember(item?.senderId)?.name,
            conversationId: selectedConversation?.conversationId,
            photos: processFileUrl(
              item?.photos,
              "/conversation/",
              selectedConversation?.conversationId,
            ),
            progress: 1,
          }))
          .reverse();
        setMessageList((prev) => [
          { shadow: true },
          ...messList,
          ...(prev?.slice(1) || []),
        ]);
        setLastMessageTs(messList[0]?.createdAt);
        setIsMoreMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        updateFirstScrollRef.current = true;
        setIsLoading(false);
      }
    });

    if (node) firstObserver.current.observe(node);
  };

  const lastElementRef = (node) => {
    if (isLoading || !isViewTargetMessage) return;
    if (lastObserver.current) lastObserver.current.disconnect();
    lastObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);

        const res = await apiFactory.messageApi.getList({
          limit: CHATTING.MESSAGE_LIMIT,
          minTs: messageList[messageList?.length - 1]?.createdAt,
          search: {
            conversationId: selectedConversation?.conversationId,
          },
          direction: "ASC",
        });

        if (res?.status !== 200) {
          openNotificationError(res?.message);
          return;
        }

        const messList = res?.data?.map((item) => ({
          ...item,
          isSelf: item?.senderId === user?.userId,
          username: getMember(item?.senderId)?.name,
          conversationId: selectedConversation?.conversationId,
          photos: processFileUrl(
            item?.photos,
            "/conversation/",
            selectedConversation?.conversationId,
          ),
          progress: 1,
        }));

        setMessageList((prev) => {
          const map = new Map(
            (prev || []).map((item) => [item.messageId, item]),
          );

          for (const message of messList) {
            map.set(message.messageId, message); // nếu trùng sẽ replace
          }

          return [...map.values()];
        });
        setIsViewTargetMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        setIsScrollToLastMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        jumpedRef.current = messList?.length === CHATTING?.MESSAGE_LIMIT;
        setIsLoading(false);
      }
    });
    if (node) lastObserver.current.observe(node);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onScrollMessageList = (event) => {
    const el = event.currentTarget;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
    wasAtBottomMessageRef.current = atBottom;
    if (atBottom) {
      setIsScrollToLastMessage(false);
      setIsNewMessage(false);
    } else {
      setIsScrollToLastMessage(true);
    }
  };

  const fetchLink = async (extractedLink) => {
    if (!extractedLink) return;

    const result = await apiFactory.previewApi.getLinkPreview({
      url: extractedLink,
    });

    if (result?.status !== 200) {
      setFormData({
        ...formData,
        previewLink: {
          image: null,
          title: null,
          description: null,
          url: null,
        },
      });
    } else {
      setFormData({
        ...formData,
        previewLink: {
          ...result?.data,
        },
      });
    }
  };

  const removePreviewLink = () => {
    setFormData({
      ...formData,
      previewLink: {
        image: null,
        title: null,
        description: null,
        url: null,
      },
    });
  };

  const closeModalConfirm = () => {
    setIsOpenModalConfirm(false);
  };

  const exitGroup = async () => {
    const memberExitGroup = await apiFactory.userConversationApi.exitGroup({
      conversationId: selectedConversation?.conversationId,
    });

    if (memberExitGroup?.status !== 200) {
      openNotificationError(memberExitGroup?.message);
      return;
    }

    openNotificationSuccess(
      languageMap?.["success.leftGroup"] ?? "You have left the group",
    );
  };

  const disableGroup = async () => {
    const result = await apiFactory.conversationApi.disableGroup(
      selectedConversation?.conversationId,
    );

    if (result?.status !== 200) {
      openNotificationError(result?.message);
    }
  };

  const enableGroup = async () => {
    const result = await apiFactory.conversationApi.enableGroup(
      selectedConversation?.conversationId,
    );

    setIsEnableGroup(false);
    setIsNewMessage(true);
    if (result?.status !== 200) {
      openNotificationError(result?.message);
    }
  };

  const isNotShowAvatar = (prevMessage, currentMessage) => {
    if (
      !prevMessage ||
      !currentMessage ||
      moment(prevMessage?.createdAt).format("YYYY-MM-DD") !==
      moment(currentMessage?.createdAt).format("YYYY-MM-DD") ||
      ![
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.FILE,
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.STICKER,
        MESSAGE_STATUS.REMOVE_MESSAGE,
      ].includes(prevMessage?.contentType)
    )
      return false;

    return prevMessage?.senderId === currentMessage?.senderId;
  };

  const isNotShowTime = (nextMessage, currentMessage) => {
    if (
      !nextMessage ||
      !currentMessage ||
      moment(nextMessage?.createdAt).format("YYYY-MM-DD hh:mm") !==
      moment(currentMessage?.createdAt).format("YYYY-MM-DD hh:mm") ||
      ![
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.FILE,
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.STICKER,
        MESSAGE_STATUS.REMOVE_MESSAGE,
      ].includes(nextMessage?.contentType)
    )
      return false;

    return nextMessage?.senderId === currentMessage?.senderId;
  };

  const getTitleAndContent = () => {
    if (isEnableGroup) {
      return {
        title: languageMap?.["menu.conversation.enableGroup"] ?? "Enable group",
        content:
          languageMap?.["modal.wantToEnable"] ??
          "Do you want to enable this group?",
      };
    }

    if (isExitGroup) {
      return {
        title: languageMap?.["menu.conversation.exitGroup"] ?? "Exit group",
        content:
          languageMap?.["modal.wantToExit"] ?? "Do you want to exit group?",
      };
    }

    return {
      title: languageMap?.["menu.conversation.disableGroup"] ?? "Disable group",
      content:
        languageMap?.["modal.wantToDisable"] ?? "Do you want to disable group?",
    };
  };

  const handleOnConfirmDisableGroup = async () => {
    closeModalConfirm();

    const disableConversationIndex = conversationList?.findIndex(
      (conversation) =>
        conversation?.conversationId === selectedConversation?.conversationId,
    );

    let updatedStatus = "INACTIVE";
    if (isEnableGroup) {
      updatedStatus = "ACTIVE";
    }

    const updatedConversation = {
      ...selectedConversation,
      conversationStatus: updatedStatus,
    };
    setSelectedConversation(updatedConversation);

    if (disableConversationIndex !== -1) {
      conversationList[disableConversationIndex] = updatedConversation;

      const newConversationListSorted = conversationList;

      handleUpdateConversationList(newConversationListSorted);
    }

    if (isEnableGroup) {
      await enableGroup();
    } else if (isExitGroup) {
      await exitGroup();
    } else {
      await disableGroup();
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    const cleanedInputValue = inputValue
      ?.split("\n")
      ?.filter((line) => line.length > 0)
      ?.join("\n");

    setFormData({
      ...formData,
      text: cleanedInputValue,
      quotation,
      previewLink: {
        image: null,
        title: null,
        description: null,
        url: null,
      },
    });

    sendFormData({
      ...formData,
      text: cleanedInputValue,
      conversationId: selectedConversation?.conversationId,
      quotation,
    });

    setInputValue("");
    setQuotation(null);
  };

  const onKeyDown = (e) => {
    // Prevent Enter during Korean/IME composition
    if (e.isComposing || e.keyCode === 229 || e.keyCode !== 13) return;

    if (!e.shiftKey) {
      sendMessage(e);
    } else if (wasAtBottomMessageRef.current) {
      // chỉ kéo xuống khi user đang ở đáy trước đó
      requestAnimationFrame(() => {
        if (messageRef.current) {
          messageRef.current.scrollTop = messageRef.current.scrollHeight;
        }
      });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();

    if (formData?.files?.length > exceedFiles) {
      openNotificationError(
        languageMap?.["error.exceed.fileNumber"] ??
        "The number of files exceeds 24",
      );
      return;
    }

    const items = event.dataTransfer?.items;
    if (items) {
      let hasFolder = false;

      for (let i = 0; i < items.length; i++) {
        const entry = items[i].webkitGetAsEntry?.();
        if (entry && entry.isDirectory) {
          hasFolder = true;
          break;
        }
      }

      if (hasFolder) {
        openNotificationError(
          languageMap?.["error.not.sendFolder"] ?? "You can not send folder",
        );
        return;
      }
    }

    const droppedFiles = Array.from(event.dataTransfer.files)?.filter(
      (file) => file?.size !== 0,
    );

    let totalSizeUpload = droppedFiles.reduce((sum, f) => sum + f.size, 0);
    if (totalSizeUpload > MAX_FILE_SIZE) {
      openNotificationError("File size exceeds the 1gb limit");
      return;
    }

    const mediaFiles = [];
    const encodePhotos = [];
    const promises = [];

    droppedFiles.forEach((file) => {
      file.uid = uuidv4();

      const promise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (e) => {
          const base64 = e?.target?.result;
          if (imagesTypes.includes(file?.type)) {
            const img = new Image();
            img.src = base64;

            img.onload = () => {
              file.width = img.width;
              file.height = img.height;
              resolve();
            };
          } else {
            mediaFiles.push(file);
            resolve();
          }
        };
      });

      promises.push(promise);
    });

    Promise.all(promises).then(() => {
      setFormData((prev) => ({
        ...prev,
        text: prev?.text,
        files: [...(prev?.files || []), ...droppedFiles],
        mediaFiles: [...(prev?.mediaFiles || []), ...mediaFiles],
        encodePhotos: [...(prev?.encodePhotos || []), ...encodePhotos],
      }));

      setUploadFiles([...uploadFiles, ...(mediaFiles || [])]);
    });
  };

  const handleFileChange = (e) => {
    if (formData?.files?.length === exceedFiles) {
      openNotificationError(
        languageMap?.["error.exceed.fileNumber"] ??
        "The number of files exceeds 24",
      );
      return;
    }

    const text = formData.text;
    const clipboardFiles = Array.from(e.clipboardData.items)
      .filter((item) => item.kind === "file")
      .map((item) => {
        const file = item.getAsFile();
        file.uid = uuidv4();
        return file;
      });

    if (clipboardFiles.length === 0) return;

    e.preventDefault();

    let mediaFiles = [];
    let encodePhotos = [];

    clipboardFiles?.forEach((file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = (r) => {
        if (imagesTypes.includes(file?.type)) {
          const img = new Image();

          img.src = r?.target?.result;

          img.onload = () => {
            file.width = img.width;
            file.height = img.height;
          };

          img.onerror = () => {
            console.error("Image loading failed");
          };
        } else {
          mediaFiles.push(file);
        }

        const updatedFiles = [...(formData?.files || []), ...clipboardFiles];
        const updatedMediaFiles = [
          ...(formData?.mediaFiles || []),
          ...mediaFiles,
        ];
        const updatedEncodePhotos = [
          ...(formData?.encodePhotos || []),
          ...encodePhotos,
        ];

        setFormData({
          text: text,
          files: updatedFiles,
          mediaFiles: updatedMediaFiles,
          encodePhotos: updatedEncodePhotos,
        });

        setUploadFiles([...uploadFiles, ...(mediaFiles || [])]);
      };
    });
  };

  const handleDataMentions = (search, callback) => {
    mentionSearchRef.current = search;
    mentionCallbackRef.current = callback;

    const mentionIds = extractUserIds(inputValue);

    const createFilteredMentionList = (mentionList) => {
      return mentionList.filter((item) => !mentionIds.includes(item?.id));
    };

    const cachedMentionAll = searchCacheMention.get("");

    if (cachedMentionAll && !cachedMentionAll.isMoreMember) {
      const filteredList = cachedMentionAll.memberMentionList.filter(
        ({ display }) =>
          removeAccents(display)
            .toLowerCase()
            .includes(removeAccents(search).toLowerCase()),
      );
      callback(createFilteredMentionList(filteredList));
      return;
    }

    const cachedMention = searchCacheMention.get(search);

    if (cachedMention) {
      callback(createFilteredMentionList(cachedMention.memberMentionList));
    } else {
      const hasConsecutiveSpaces = /\s{2,}/.test(search);

      if (hasConsecutiveSpaces) return;

      debounceFetchMembers(
        search,
        (members) => {
          callback(createFilteredMentionList(members));
        },
        selectedConversation?.conversationId,
      );
    }
  };

  const fetchMembers = async (
    memberName,
    callback,
    conversationId,
    page = 1,
  ) => {
    setIsLoading(true);

    try {
      const request = {
        conversationId: conversationId,
        limit: 30,
        page,
        search: { memberName, viewType: "ALL" },
        ts: moment(),
      };

      const result =
        await apiFactory?.userConversationApi?.getListUserConversation(request);
      setIsLoading(false);

      if (result?.status === 200) {
        const newMembers =
          result?.data?.items?.map(({ userId, name, avatar }) => ({
            id: userId,
            display: name,
            avatar,
          })) || [];

        setSearchCacheMention((prevCache) => {
          const cache = new Map(prevCache);
          const existingData = cache.get(memberName) || {
            memberMentionList: [],
            memberPage: 1,
            isMoreMember: false,
          };
          let updatedList =
            page === 1
              ? newMembers
              : [...existingData.memberMentionList, ...newMembers];

          if (!updatedList.some((member) => member.id === "ALL")) {
            updatedList = [{ id: "ALL", display: "All" }, ...updatedList];
          }

          const userLogin = useInfoUser.getState().user;

          cache.set(memberName, {
            memberMentionList: updatedList.filter(
              (item) => item?.id !== userLogin?.userId,
            ),
            memberPage: page + 1,
            isMoreMember: newMembers.length === 30,
          });
          callback(
            updatedList.filter((item) => item?.id !== userLogin?.userId),
          );
          return cache;
        });

        updateOrgList(setOriginalOrgList, result?.data?.items);
      } else {
        openNotificationError(result?.message);
      }
    } catch (error) {
      setIsLoading(false);
      openNotificationError("Failed to fetch members.");
    }
  };

  const handleScroll = useCallback(
    (event) => {
      const target = event.target;
      const cachedData = searchCacheMention.get(mentionSearchRef.current);

      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight &&
        cachedData?.isMoreMember
      ) {
        fetchMembers(
          mentionSearchRef.current,
          mentionCallbackRef.current,
          selectedConversation?.conversationId,
          cachedData.memberPage,
        );
      }
    },
    [searchCacheMention, selectedConversation?.conversationId],
  );

  const debounceFetchMembers = useCallback(debounce(fetchMembers, 600), []);

  const renderMemberTyping = useMemo(() => {
    if (!Object.entries(typingUsers)?.length) return;

    if (Object.entries(typingUsers)?.length === 1) {
      return (
        <div className="typing">
          {Object.values(typingUsers)?.[0]?.userName}
          {user?.language === "us" && " is"}{" "}
          {languageMap?.["chat.user.typing"] ?? "typing"}{" "}
        </div>
      );
    }

    return (
      Object.entries(typingUsers).length > 0 && (
        <div className="typing">
          {Object.values(typingUsers)
            ?.map((typingUser) => typingUser?.userName)
            ?.slice(0, 3)
            ?.join(", ")}{" "}
          {user?.language === "us" && "are"}{" "}
          {languageMap?.["chat.user.typing"] ?? "typing"}{" "}
        </div>
      )
    );
  }, [typingUsers, languageMap]);

  const extractSingleLink = async (text) => {
    const urlRegex = /https?:\/\/[^\s]+/g;
    const matches = text.match(urlRegex);

    if (matches?.length === 1) {
      await fetchLink(matches[0]);
    } else {
      setFormData({
        ...formData,
        previewLink: {
          image: null,
          title: null,
          description: null,
          url: null,
        },
      });
    }
  };

  const handleAddEmoji = (emojiKey) => {
    if (inputSendRef?.current?.insertEmoji) {
      inputSendRef.current.focus();
      inputSendRef.current.insertEmoji(emojiKey);
    }
  };

  const handleSendSticker = async (sticker) => {
    const payload = {
      conversationId: selectedConversation?.conversationId,
      requestUuid: uuidv4(),
      stickerId: sticker.stickerId,
      content: sticker.resourceId,
      token: Cookies.get("access_token"),
      contentType: "STICKER",
      frameCount: sticker.frameCount,
    };

    await apiFactory.messageApi.sendMessage(payload);
  };

  const getContainer = () => {
    return messageRef?.current || document.querySelector(".message-detail");
  };

  const getSender = () => {
    if (
      !selectedConversation?.memberList?.length ||
      !selectedConversation?.members?.length ||
      !user?.userId
    )
      return null;

    const otherUserId = selectedConversation?.memberList.find(
      (id) => id?.toLowerCase() !== user.userId.toLowerCase(),
    );

    if (!otherUserId) return null;

    const member = getMember(otherUserId);

    if (!member)
      return selectedConversation?.members.find(
        (m) => m.userId?.toLowerCase() === otherUserId.toLowerCase(),
      );

    return member;
  };

  const onCall = (mode) => {
    if (selectedConversation?.type === conversationType.PERSONAL) {
      openCall(selectedConversation?.memberList, mode);
    } else {
      setIsPickCallMember(true);
      setCallingType(mode);
    }
  };

  const refreshConversation = () => {
    refreshChatMessage();
    setIsMessageUnread(false);
  };

  const toggleGroupInfo = () => {
    setPanelStatus((prev) => {
      if (
        [PANEL_STATUS.GROUP_INFO, PANEL_STATUS.MEDIA_STORAGE].includes(prev)
      )
        return null;
      return PANEL_STATUS.GROUP_INFO;
    });
  };

  useEffect(() => {
    const interval = setInterval(
      () => {
        setSearchCacheMention(new Map());
      },
      60 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (messageRef.current) {
      if (updateInitScrollRef.current) {
        updateInitScrollRef.current = false;
        messageRef.current.scrollTop = messageRef.current.scrollHeight;
        wasAtBottomMessageRef.current = true;
      }

      if (updateFirstScrollRef.current) {
        updateFirstScrollRef.current = false;
        messageRef.current.scrollTop =
          messageRef.current.scrollHeight - previousScrollRef.current;
      }

      if (
        wasAtBottomMessageRef.current &&
        messageRef.current &&
        !jumpedRef.current
      ) {
        delay(() => {
          if (messageRef?.current)
            messageRef.current.scrollTop = messageRef.current.scrollHeight;
        }, 200);
      }
    }
  }, [messageList]);

  // useEffect(() => {
  //   if (!headerRef.current) return;
  //
  //   const observer = new ResizeObserver((entries) => {
  //     for (let entry of entries) {
  //       const newHeight = entry.contentRect.height;
  //       setHeightHeader(newHeight);
  //     }
  //   });
  //
  //   observer.observe(headerRef.current);
  //
  //   return () => observer.disconnect();
  // }, []);

  useEffect(() => {
    let suggestionsList = null;

    const handleScrollBar = () => {
      const newSuggestionsList = document.querySelector(
        ".mentions__suggestions",
      );
      if (newSuggestionsList !== suggestionsList) {
        if (suggestionsList) {
          suggestionsList.removeEventListener("scroll", handleScroll);
        }
        if (newSuggestionsList) {
          newSuggestionsList.addEventListener("scroll", handleScroll);
        }
        suggestionsList = newSuggestionsList;
      }
    };

    const observer = new MutationObserver(handleScrollBar);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (suggestionsList) {
        suggestionsList.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    const container = getContainer();
    if (!container) {
      return;
    }

    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    observerRef.current = new IntersectionObserver(
      (entries) => {
        let changed = false;

        entries.forEach((entry) => {
          const el = entry.target;
          if (!el || !(el instanceof HTMLElement)) return;

          if (entry.isIntersecting) {
            if (el.dataset.isUnread === "1") {
              el.dataset.isUnread = "0";
              changed = true;
              try {
                observerRef.current.unobserve(el);
              } catch (e) { }
            }
          }
        });

        if (changed) {
          const containerNow = getContainer();
          const readCount = containerNow
            ? containerNow.querySelectorAll('.message-item[data-is-unread="0"]')
              .length
            : 0;
          setUnreadInDOM(readCount);
        }
      },
      {
        root: container,
        threshold: 0.1,
      },
    );

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  return (
    <div className="chat-detail-layout overflow-hidden flex flex-row flex-1">
      <div className="w-full">
        <DndContext>
          <div
            className="chat-content h-[100vh]"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div
              className={`header border-b-[1px] border-[#ddd] shadow-md z-10000
                 ${pinnedMessages?.length > 0 && "mb-[50px]"}
                `}
              ref={headerRef}
            >
              <div className="left-chat">
                <button
                  className="btn-back-to-conversation-list"
                  onClick={onBackToConversations}
                >
                  <LeftOutlined />
                </button>
                {selectedConversation?.type === "PERSONAL" ? (
                  <MemberAvatar
                    person={getSender()}
                    size={50}
                    onlineSize="medium"
                  />
                ) : (
                  <AvatarComponent conversation={selectedConversation} />
                )}

                <div>
                  <div className="text-[#000] text-[16px] font-bold">
                    {selectedConversation?.name}
                  </div>
                  <TotalMember />
                  {conversationType.PERSONAL === selectedConversation?.type && (
                    <OnOffTime personalDetail={personalDetail} />
                  )}
                </div>
                {selectedConversation?.type !== conversationType.SYSTEM &&
                  selectedConversation?.conversationStatus === "ACTIVE" &&
                  (selectedConversation?.role === role?.HOST ||
                    selectedConversation?.type ===
                    conversationType.PERSONAL) && (
                    <button onClick={openModal}>
                      <div className="icon-edit">
                        <AiFillEdit className="text-[#333333] text-[16px] center" />
                      </div>
                    </button>
                  )}
              </div>
              <button
                className="icon menu-icon"
                onClick={() => {
                  setIsMenu(true);
                }}
              >
                <IoMenu size={25} />
              </button>

              <div className="right">
                {selectedConversation?.type !== conversationType.SELF && (
                  <>
                    <Tooltip
                      placement="bottom"
                      title={
                        languageMap?.["menu.conversation.audioCall"] ??
                        "Audio call"
                      }
                      color={"#0091ff"}
                    >
                      <Button
                        className="bg-[#2a56b9] text-[white]"
                        onClick={() => onCall("audio")}
                        icon={<LuPhone className="text-[17px]" />}
                      />
                    </Tooltip>
                    <Tooltip
                      placement="bottom"
                      title={
                        languageMap?.["menu.conversation.videoCall"] ??
                        "Video call"
                      }
                      color={"#0091ff"}
                    >
                      <Button
                        className="bg-[#2a56b9] text-[white]"
                        onClick={() => onCall("video")}
                        icon={<LuVideo className="text-[18px]" />}
                      />
                    </Tooltip>
                  </>
                )}
                {selectedConversation?.role !== role.MEMBER &&
                  selectedConversation?.conversationStatus === "ACTIVE" &&
                  ![conversationType.PERSONAL, conversationType.SELF].includes(
                    selectedConversation?.type,
                  ) && (
                    <Tooltip
                      placement="bottom"
                      title={
                        languageMap?.["menu.conversation.addMember"] ??
                        "Add more members"
                      }
                      trigger={"hover"}
                      color={"#0091ff"}
                    >
                      <div>
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          onClick={openAddMemberModal}
                          icon={<GoPersonAdd size={18} />}
                        />
                      </div>
                    </Tooltip>
                  )}

                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.searchMessage"] ??
                    "Search messages"
                  }
                  color={"#0091ff"}
                >
                  <Button
                    className="bg-[#2a56b9] text-[white]"
                    onClick={onSearch}
                    icon={<IoSearchSharp className="text-[18px]" />}
                  />
                </Tooltip>

                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.refresh"] ?? "Refresh"
                  }
                  color={"#0091ff"}
                >
                  <div>
                    <Button
                      className="bg-[#2a56b9] text-[white]"
                      onClick={refreshConversation}
                      icon={<HiRefresh className="text-[18px]" />}
                    />
                  </div>
                </Tooltip>
                {selectedConversation?.type === conversationType.GROUP && (
                  <>
                    {isExitGroup && (
                      <Tooltip
                        placement="bottom"
                        title={
                          languageMap?.["menu.conversation.exitGroup"] ??
                          "Exit group"
                        }
                        color="#0091ff"
                      >
                        <Button
                          className="bg-[#2a56b9] text-white"
                          onClick={openModalConfirm}
                          icon={<MdExitToApp className="text-[18px]" />}
                        />
                      </Tooltip>
                    )}
                    {selectedConversation?.conversationStatus ===
                      conversationStatus.ACTIVE &&
                      !isExitGroup && (
                        <Tooltip
                          placement="bottom"
                          title={
                            languageMap?.["menu.conversation.disableGroup"] ??
                            "Disable group"
                          }
                          color="#0091ff"
                        >
                          <Button
                            className="bg-[#2a56b9] text-white"
                            onClick={openModalConfirm}
                            icon={<MdOutlineGroupOff className="text-[18px]" />}
                          />
                        </Tooltip>
                      )}
                    {selectedConversation?.conversationStatus ===
                      conversationStatus.INACTIVE &&
                      !isExitGroup && (
                        <Tooltip
                          placement="bottom"
                          title={
                            languageMap?.["menu.conversation.enableGroup"] ??
                            "Enable group"
                          }
                          color="#0091ff"
                        >
                          <Button
                            className="bg-[#2a56b9] text-white"
                            onClick={() => {
                              setIsEnableGroup(true);
                              openModalConfirm();
                            }}
                            icon={<HiMiniUserGroup className="text-[18px]" />}
                          />
                        </Tooltip>
                      )}
                  </>
                )}
                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.groupInfo"] ??
                    "Group information"
                  }
                  color={"#0091ff"}
                >
                  <div>
                    <Button
                      className="bg-[#2a56b9] text-white"
                      onClick={toggleGroupInfo}
                      icon={
                        <VscLayoutSidebarRight
                          size={20}
                          className="!text-[18px]"
                        />
                      }
                    />
                  </div>
                </Tooltip>
              </div>
            </div>

            <div className="pinned-message">
              <PinnedMessageModal
                heightHeader={heightHeader}
              />
            </div>
            <div
              className="bg-[#EAEEF0] overflow-y-scroll border-none outline-none message-detail w-[100%] px-[10px]"
              ref={messageRef}
              tabIndex={0}
              onFocus={() => setKeydownMenuOn(false)}
              onBlur={() => setKeydownMenuOn(true)}
              onScroll={onScrollMessageList}
              onClick={() => setShowSticker(false)}
            >
              {(isJumping || isLoading) && (
                <div className="spin-container">
                  <Spin
                    indicator={<LoadingOutlined className="text-[35px]" spin />}
                  />
                </div>
              )}
              <UnreadCountCircle />
              {messageList?.map((message, index) => {
                const isUnreadInit =
                  selectedConversation?.lastSeenTs < message.createdAt
                    ? "1"
                    : "0";

                if (index === 0) {
                  //add more shadow message
                  return (
                    <div
                      key={"shadow-item"}
                      ref={firstElementRef}
                      className="h-[100px]"
                    />
                  );
                }

                if (index === messageList?.length - 1) {
                  return (
                    <div
                      key={message?.requestUuid}
                      className="message-item"
                      ref={(el) => {
                        if (el) {
                          lastElementRef(el);

                          messageMapRef.current[message?.requestUuid] = el;

                          el.dataset.isUnread =
                            el.dataset.isUnread ?? isUnreadInit;

                          if (
                            observerRef.current &&
                            el.dataset.isUnread === "1"
                          ) {
                            try {
                              observerRef.current.observe(el);
                            } catch (e) { }
                          }
                        }
                      }}
                      data-is-unread={
                        selectedConversation.lastSeenTs < message.createdAt
                          ? "1"
                          : "0"
                      }
                    // data-request-uuid={message?.requestUuid}
                    >
                      <UnreadLine message={message} />
                      <GenerateMessageContent
                        isNotShowAvatar={isNotShowAvatar(
                          index > 0 ? messageList?.[index - 1] : {},
                          message,
                        )}
                        isNotShowTime={isNotShowTime(
                          index > 0 ? messageList?.[index + 1] : {},
                          message,
                        )}
                        message={message}
                        fileStore={fileStore}
                        setIsModalMembersReadUnread={
                          setIsModalMembersReadUnread
                        }
                        setSelectedMessage={setSelectedMessage}
                        selectedConversation={selectedConversation}
                        setQuotation={setQuotation}
                        jumpToMessage={jumpToMessage}
                        viewTargetMessage={viewTargetMessage}
                        inputSendRef={inputSendRef}
                        setIsShareMessageModal={setIsShareMessageModal}
                        setDataShare={setDataShare}
                      />
                      <div className="h-[28px]" />
                    </div>
                  );
                }

                return (
                  <div
                    key={message?.requestUuid}
                    className="message-item"
                    data-is-unread={
                      selectedConversation.lastSeenTs < message.createdAt
                        ? "1"
                        : "0"
                    }
                    ref={(el) => {
                      if (el) {
                        messageMapRef.current[message?.requestUuid] = el;

                        el.dataset.isUnread =
                          el.dataset.isUnread ?? isUnreadInit;

                        if (
                          observerRef.current &&
                          el.dataset.isUnread === "1"
                        ) {
                          try {
                            observerRef.current.observe(el);
                          } catch (e) { }
                        }
                      }
                    }}
                  >
                    <UnreadLine message={message} />
                    <GenerateMessageContent
                      isNotShowAvatar={isNotShowAvatar(
                        index > 0 ? messageList[index - 1] : {},
                        message,
                      )}
                      isNotShowTime={isNotShowTime(
                        messageList?.[index + 1] || {},
                        message,
                      )}
                      message={message}
                      fileStore={fileStore}
                      setIsModalMembersReadUnread={setIsModalMembersReadUnread}
                      setSelectedMessage={setSelectedMessage}
                      selectedConversation={selectedConversation}
                      setQuotation={setQuotation}
                      jumpToMessage={jumpToMessage}
                      viewTargetMessage={viewTargetMessage}
                      inputSendRef={inputSendRef}
                      setIsShareMessageModal={setIsShareMessageModal}
                      setDataShare={setDataShare}
                    />
                  </div>
                );
              })}
              <NewMessage />
            </div>
            {selectedConversation?.type !== conversationType.SYSTEM &&
              selectedConversation?.conversationStatus === "ACTIVE" && (
                <div
                  className="bg-[#ffffff] input relative !p-[0] z-[101]"
                  style={{
                    borderTopLeftRadius:
                      Object.entries(typingUsers)?.length > 0 ? "unset" : "",
                  }}
                >
                  {renderMemberTyping}

                  <div className="w-[100%] flex flex-col">
                    <div className="border-y-[1px] border-[#ddd] px-[10px] py-[5px] gap-2 flex">
                      <StickerTable
                        onStickerSend={handleSendSticker}
                        onEmojiSelect={handleAddEmoji}
                      />

                      <FileSending
                        formData={formData}
                        setFormData={setFormData}
                      />

                      <Tooltip
                        placement="top"
                        title={
                          languageMap?.["modal.conversation.vote"] ?? "Vote"
                        }
                        color={"#0091ff"}
                      >
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          icon={<MdOutlineHowToVote className="text-[18px]" />}
                          onClick={() => setIsOpenModalVote(true)}
                        />
                      </Tooltip>

                      <Tooltip
                        placement="top"
                        title={
                          languageMap?.["modal.conversation.schedule"] ??
                          "Schedule"
                        }
                        color={"#0091ff"}
                      >
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          icon={<LuAlarmClock className="text-[18px]" />}
                          onClick={() => setIsChatScheduleModal(true)}
                        />
                      </Tooltip>
                    </div>

                    <QuotationResponse
                      quotation={quotation}
                      setQuotation={setQuotation}
                    />
                    {formData?.previewLink?.image && (
                      <ChatPreviewLink
                        previewLink={formData?.previewLink}
                        removePreviewLink={removePreviewLink}
                      />
                    )}

                    <div className="flex w-[100%] items-center">
                      {inputValue &&
                        showSticker &&
                        stickerSuggestions.length > 0 && (
                          <div className="sticker-suggestions">
                            {stickerSuggestions.map((item) => (
                              <div
                                className="sticker-item-wrapper"
                                key={item.stickerId}
                                onClick={async (e) => {
                                  e.preventDefault();
                                  setShowSticker(false);
                                  await handleSendSticker(item);
                                  setInputValue("");
                                }}
                              >
                                <StickerItem
                                  resourceId={item.resourceId}
                                  frameCount={item.frameCount}
                                  size={60}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      <ContentEditableRichInput
                        value={inputValue}
                        onChange={(event) => {
                          setInputValue(event.target.value);
                          extractSingleLink(event.target.value);
                          handleTyping();
                        }}
                        placeholder={
                          languageMap?.["messageList.input.placeholder"] ??
                          "Message"
                        }
                        handleDataMentions={handleDataMentions}
                        ref={inputSendRef}
                        renderSuggestion={(item) => (
                          <div className="flex items-center gap-2 py-1">
                            <Avatar
                              style={{
                                backgroundColor: getColorFromInitial(
                                  item?.display[0],
                                ),
                                color: "white",
                                fontSize: "0.75rem",
                              }}
                              size={32}
                              src={item?.avatar ? getAvatar(item) : null}
                            >
                              {item?.id === "ALL" ? "@" : item?.display[0]}
                            </Avatar>
                            <span className="text-[0.75rem]">
                              {item?.id === "ALL"
                                ? languageMap?.[
                                "messageList.input.mentionAll"
                                ] ?? "Notify all group members @ALL"
                                : item?.display}
                            </span>
                          </div>
                        )}
                        onPaste={handleFileChange}
                        onKeyDown={onKeyDown}
                        onClick={() =>
                          onChangeUnreadConversation(
                            conversationList?.find(
                              (conversation) =>
                                conversation.conversationId ===
                                selectedConversation.conversationId,
                            ),
                            conversationList,
                            handleUpdateConversationList,
                          )
                        }
                        setStickerSuggestions={setStickerSuggestions}
                        setShowSticker={setShowSticker}
                        stickerKeywords={stickerKeywords}
                      />
                      <Button
                        className="bg-[#2a56b9] text-[white] mr-[10px]"
                        onClick={sendMessage}
                        icon={<FiSend size={16} />}
                      />
                    </div>

                    <FilesPreview
                      formData={formData}
                      setFormData={setFormData}
                      isOnlyView={true}
                    />
                  </div>
                </div>
              )}
          </div>
        </DndContext>

        {isShareMessageModal && (
          <ShareMessageModal
            isModalOpen={isShareMessageModal}
            isModalClose={() => setIsShareMessageModal(false)}
            shareMessage={dataShare}
          />
        )}

        {isPickCallMember && (
          <DirectoryProvider>
            <PickMemberModal
              selectedConversation={selectedConversation}
              isPickCallMember={isPickCallMember}
              setIsPickCallMember={setIsPickCallMember}
              memberIds={[user?.userId]}
            />
          </DirectoryProvider>
        )}

        {isModalOpen && (
          <EditGroupModal
            isOpen={isModalOpen}
            onClose={closeModal}
            data={selectedConversation}
          />
        )}

        {isModalAddMember && (
          <AddMemberModal
            isModalOpen={isModalAddMember}
            isModalClose={() => setIsModalAddMember(false)}
            conversationId={selectedConversation.conversationId}
            conversationName={selectedConversation.name}
            orgList={orgList}
            setOrgList={setOrgList}
            screen={conversationType.CONVERSATION}
          />
        )}

        {isOpenModalConfirm && (
          <GeneralModal
            title={getTitleAndContent()?.title}
            content={getTitleAndContent()?.content}
            onCancel={closeModalConfirm}
            open={isOpenModalConfirm}
            onConfirm={handleOnConfirmDisableGroup}
          />
        )}

        <SideBarConversation
          isExitGroup={isExitGroup}
          isOpen={isMenu}
          onClose={() => setIsMenu(false)}
          onCall={onCall}
          onRefresh={refreshConversation}
          onToggleGroupInfo={toggleGroupInfo}
        />

        {isModalMembersReadUnread && (
          <MemberReadUnreadModal
            conversationId={selectedConversation?.conversationId}
            conversationType={selectedConversation?.type}
            messageId={selectedMessage?.messageId}
            onCancel={() => setIsModalMembersReadUnread(false)}
            isOpen={isModalMembersReadUnread}
          />
        )}

        {isChatScheduleModal && (
          <ChatScheduleModal
            onCancel={() => {
              setIsChatScheduleModal(false);
              setScheduleMessage(null);
            }}
            open={isChatScheduleModal}
            onConfirm={() => { }}
          />
        )}

        {isOpenModalVote && (
          <CreateVoteModal
            isOpen={isOpenModalVote}
            onClose={() => setIsOpenModalVote(false)}
          />
        )}
      </div>

      {panelStatus === PANEL_STATUS.GROUP_INFO && (
        <GroupInfoPanel jumpToMessage={jumpToMessage} />
      )}
      {panelStatus === PANEL_STATUS.MEDIA_STORAGE && (
        <MediaStoragePanel jumpToMessage={jumpToMessage} />
      )}
      {[
        PANEL_STATUS.SEARCH_CHAT,
        PANEL_STATUS.SEARCH_CHAT_AFTER_GROUP_INFO,
      ].includes(panelStatus) && <SearchPanel jumpToMessage={jumpToMessage} />}
    </div>
  );
};

export { ChatDetail };
